import { useRecoilValue } from "recoil";
import { PaymentMethod } from "../../../../../../api/tournament-participant";
import { pubState } from "../../../../../../recoil/pub.atom";
import { MoreItem, MoreWrapper } from "./style";
import { exchangePoint } from "../../../../../../utils/number";

export interface DialogPayType {
  name: string;
  type?: PaymentMethod;
  value: number;
  unit: string;
  set?: (v: number) => void;
  weight?: boolean;
}

interface MoreInfoProps {
  name: string;
  dialogPayType: DialogPayType[];
  addStack?: number;
}
const MoreInfo = ({ name, dialogPayType, addStack }: MoreInfoProps) => {
  const pub = useRecoilValue(pubState);
  return (
    <MoreWrapper>
      <div className="name">{name}</div>
      <div className="info">
        {dialogPayType.length === 0 ? (
          <MoreItem>내역이 존재하지 않습니다. </MoreItem>
        ) : (
          dialogPayType.map((item, index) => (
            <MoreItem key={index}>
              <div className="name">{item.name}</div>
              <div>
                {item.value
                  ? item?.type === PaymentMethod.POINTS && pub
                    ? exchangePoint(item.value)
                    : item.value.toLocaleString()
                  : 0}{" "}
                {item.unit}
              </div>
            </MoreItem>
          ))
        )}
        {addStack ? (
          <MoreItem>
            <div className="name">추가 스택</div>
            <div>{addStack.toLocaleString()}</div>
          </MoreItem>
        ) : (
          ""
        )}
      </div>
    </MoreWrapper>
  );
};

export default MoreInfo;
